module.exports = __webpack_public_path__ + "static/media/playstore_icon.663fd35b.png";